import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { TableConfig } from 'src/app/shared/components/app-table/app-table-models';
import { ResistanceCalculationResultDTO } from '../../models/analys-resultat';
import { AnalysresultatService } from '../analysresultat.service';
@Component({
    selector: 'app-antibiotic-calc',
    templateUrl: './antibiotic-calc.component.html',
    styleUrl: './antibiotic-calc.component.scss',
    standalone: false
})
export class AntibioticCalcComponent implements OnInit, AfterViewInit {

  private analysresultatService = inject(AnalysresultatService);
  protected tableConfig: TableConfig = { columns: [] };
  protected calcData!: ResistanceCalculationResultDTO[];
  protected searchParams!: any;
  protected loading = true;
  ngOnInit(): void {
    this.tableConfig.columns = [
      { header: 'Antibiotika', field: 'antibioticName', sortByField: 'antibioticName' },
      { header: 'Totalt antal testade', field: 'total_sir', sortByField: 'total_sir' },
      { header: 'S antal', field: 'sir_s', sortByField: 'sir_s' },
      { header: 'S (%)', field: 'sir_s_percent', sortByField: 'sir_s_percent', mapView: (x) => (x * 100).toFixed(1) },
      { header: 'I antal', field: 'sir_i', sortByField: 'sir_i' },
      { header: 'I (%)', field: 'sir_i_percent', sortByField: 'sir_i_percent', mapView: (x) => (x * 100).toFixed(1) },
      { header: 'R antal', field: 'sir_r', sortByField: 'sir_r' },
      { header: 'R (%)', field: 'sir_r_percent', sortByField: 'sir_r_percent', mapView: (x) => (x * 100).toFixed(1) },
      { header: 'Totalt antal testade', field: 'total_tolk', sortByField: 'total_tolk' },
      { header: 'S antal', field: 'tolk_s', sortByField: 'tolk_s' },
      { header: 'S (%)', field: 'tolk_s_percent', sortByField: 'tolk_s_percent', mapView: (x) => (x * 100).toFixed(1) },
      { header: 'I antal', field: 'tolk_i', sortByField: 'tolk_i' },
      { header: 'I (%)', field: 'tolk_i_percent', sortByField: 'tolk_i_percent', mapView: (x) => (x * 100).toFixed(1) },
      { header: 'R antal', field: 'tolk_r', sortByField: 'tolk_r' },
      { header: 'R (%)', field: 'tolk_r_percent', sortByField: 'tolk_r_percent', mapView: (x) => (x * 100).toFixed(1) },
    ];
    this.searchParams = JSON.parse(localStorage.getItem('searchParams') as any);
    this.calc();
  }

  ngAfterViewInit(): void {
    this.loading = true;
  }

  calc() {
    this.loading = true;
    this.analysresultatService
      .calculateResistance<ResistanceCalculationResultDTO[]>(this.searchParams)
      .subscribe((calcResult: ResistanceCalculationResultDTO[]) => {
        calcResult.forEach((x) => {
          x.sir_s_percent = Number((x.sir_s_percent * 100).toFixed(1));
          x.sir_i_percent = Number((x.sir_i_percent * 100).toFixed(1));
          x.sir_r_percent = Number((x.sir_r_percent * 100).toFixed(1));

          x.tolk_s_percent = Number((x.tolk_s_percent * 100).toFixed(1));
          x.tolk_i_percent = Number((x.tolk_i_percent * 100).toFixed(1));
          x.tolk_r_percent = Number((x.tolk_r_percent * 100).toFixed(1));
        });
        this.calcData = calcResult.sort((a, b) => (a.antibioticName > b.antibioticName ? 1 : -1));
        this.loading = false;
      });
  }
}
